import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function StoreVisit() {
  const { subdomain } = useParams();
  useEffect(() => {
    window.open(`/store/${subdomain}`, "_blank");
  }, [subdomain]);

  return (
    <div data-testid="store-visit-page" className="p-10 text-center">
      <h2 className="font-display font-bold text-2xl text-black">Opening your storefront…</h2>
      <p className="text-black/55 mt-2">If a new tab didn't open, click below.</p>
      <a href={`/store/${subdomain}`} target="_blank" rel="noopener noreferrer"
        className="inline-block mt-4 px-5 py-2.5 rounded-xl bg-gradient-to-r from-[#1FA868] to-[#16834D] text-white text-sm font-bold">
        Visit /store/{subdomain}
      </a>
    </div>
  );
}
